import { FiCamera } from 'react-icons/fi';

import { FOCO_VISIVEL } from 'utils/foco';

/** Sem foto, no modo "Com sua foto": o aviso amarelo acima dos selos, como no Meu Perfil v2 (AJ2-23). */
export default function AvisoDeFoto({ onAtualizarFoto }: { onAtualizarFoto: () => void }) {
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-xl bg-brand-yellow-light px-5 py-4">
      <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-blue text-brand-yellow">
        <FiCamera size={20} />
      </span>
      <div className="flex min-w-[220px] flex-1 flex-col gap-1">
        <p className="m-0 font-display text-[15px] font-bold text-brand-blue-dark">Compartilhe sua conquista com a sua foto!</p>
        <p className="m-0 text-[13px] leading-[1.45] text-content">
          Para ter uma foto para compartilhamento, você precisa alterar sua foto de perfil, fazendo o upload com sua imagem.
        </p>
      </div>
      <button
        type="button"
        onClick={onAtualizarFoto}
        className={`cursor-pointer rounded-[6px] border-0 bg-brand-blue px-[18px] py-3 font-display text-xs font-bold uppercase text-brand-white hover:brightness-110 ${FOCO_VISIVEL}`}
      >
        Atualizar foto de perfil
      </button>
    </div>
  );
}
